import React, { useState } from "react";
import expandArrow from "../../assets/expand_arrow.png";
import collapseArrow from "../../assets/collapse_arrow.png";

import "./InstallerPackCard.css";

function InstallerPackCard({ iconSrc, title, collapseId, children }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="installer-pack-card py-4 px-4 my-2">
      <div
        className="installer-pack-card-header"
        role="button"
        data-toggle="collapse"
        data-target={`#${collapseId}`}
        aria-expanded="true"
        aria-controls={collapseId}
        onClick={handleCollapse}
      >
        <i className={`icon icon-${iconSrc} text-purple`} />
        <p className="bold m-0">{title}</p>
        <div>
          {isCollapsed ? (
            <img src={collapseArrow} alt="Collapse Button" width={30} />
          ) : (
            <img src={expandArrow} alt="Expand Button" width={30} />
          )}
        </div>
      </div>
      <div className="mt-4 collapse show" id={collapseId}>
        {children}
      </div>
    </div>
  );
}

export default InstallerPackCard;
